import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithReauth from '../../app/baseQueryWithOnlineCourse'
import { HomeworkAnalysisState } from '../types'

interface getStudentTopicHomeworkAnalysisParams {
    courseSubjectId: number
    userCourseEnrollId: number
}

export const homeworkApiSlice = createApi({
    reducerPath: 'homeworkApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Homework'],
    endpoints: (build) => ({
        getHomeworkByCourseTopic: build.query<any, number>({
            query: (courseTopicId) => ({
                url: 'homework',
                params: {
                    courseTopicId,
                },
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'Homework' as const,
                            id,
                        })),
                        { type: 'Homework', id: 'LIST' },
                    ]
                    : [{ type: 'Homework', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),



        updateHomework: build.mutation<any, { id: number; body: FormData }>({
            query: ({ id, body }) => ({
                url: `homework/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: 'Homework', id: 'LIST' }],
        }),

        createHomework: build.mutation<any, { courseTopicId: number; body: FormData }>({
            query: ({ body }) => ({
                url: `homework`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Homework', id: 'LIST' }],
        }),

        deleteHomework: build.mutation<void, number>({
            query: (id) => ({
                url: `homework/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Homework', id: 'LIST' }],
        }),
        deleteHomeworkFile: build.mutation<void, number>({
            query: (homeworkFileId) => ({
                url: `homework/homeworkFile/${homeworkFileId}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Homework', id: 'LIST' }],
        }),

        gradeHomework: build.mutation<any, { homeworkId: number, body: { point: number, feedback: string } }>({
            query: ({ homeworkId, body }) => ({
                url: `homework/student/${homeworkId}/check`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'Homework', id: 'LIST' }],
        }),

        getStudentTopicHomeworkAnalysis: build.query<
            HomeworkAnalysisState[],
            getStudentTopicHomeworkAnalysisParams
        >({
            query: ({ courseSubjectId, userCourseEnrollId }) => ({
                url: `homework/student?courseSubjectId=${courseSubjectId}&userCourseEnrollId=${userCourseEnrollId}`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'Homework' as const,
                            id,
                        })),
                        { type: 'Homework', id: 'LIST' },
                    ]
                    : [{ type: 'Homework', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),
    }),
})     